import { Typography, useTheme } from "@mui/material";

export default function OrganizationSection({ name }: { name?: string }) {
  const theme = useTheme();
  return (
    <Typography
      sx={{
        color: theme.nawy.colors.semantic.text.secondary,
        ...theme.nawy.typography.english.variants.body.md.regular,
      }}
    >
      {name || "No Organization"}
    </Typography>
  );
}
